
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import DismissModal from './DismissModal';
import useRiskSignalsFunctions from './useRiskSignalsFunctions';
import Header from './Header';
import Filters from './Filters';
import RiskSignalTable from './RiskSignalTable';
import Pagination from './Pagination';
import { S } from '../regureStyles';

// ─── Risk Signals Page ────────────────────────────────────
const RiskSignalsScreen = () => {
  const { t } = useTranslation();

  const SIGNAL_LABELS = {
    stale_claim:         t('screens.riskSignals.labelStaleClaim'),
    sla_breach_warning:  t('screens.riskSignals.labelSlaWarning'),
    sla_breached:        t('screens.riskSignals.labelSlaBreached'),
    reserve_inadequacy:  t('screens.riskSignals.labelReserveInadequacy'),
    high_severity:       t('screens.riskSignals.labelHighSeverity'),
    litigation_risk:     t('screens.riskSignals.labelLitigationRisk'),
    duplicate_suspect:   t('screens.riskSignals.labelDuplicateSuspect'),
    fraud_indicator:     t('screens.riskSignals.labelFraudIndicator'),
    escalation_needed:   t('screens.riskSignals.labelEscalationNeeded'),
    document_missing:    t('screens.riskSignals.labelDocumentMissing'),
  };


  const {
    severity,
    setSeverity,
    status,
    setStatus,
    type,
    setType,
    search,
    setSearch,
    page,
    setPage,
    total,
    loading,
    config,
    dismissTarget,
    setDismissTarget,
    showConfig,
    setShowConfig,
    actionLoading,
    selected,
    fetchSignals,
    handleAcknowledge,
    handleResolve,
    handleDismissConfirm,
    handleSaveConfig,
    handleBulkAcknowledge,
    fmtDate,
    pages,
    toggleSelect,
    toggleAll,
    filteredSignals,
    PAGE_SIZE,
    setPageSize,
  } = useRiskSignalsFunctions();

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Header */}
        <Header setShowConfig={setShowConfig} fetchSignals={fetchSignals} />

        <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
          {/* AI evaluation banner */}
          <div style={{ margin: '16px 32px 0', padding: '14px 18px', background: '#faf8f9', borderLeft: `4px solid ${S.burgundy}`, borderRadius: '0 10px 10px 0', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={S.burgundy} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
            <div style={{ fontSize: 13, color: S.textSecondary, lineHeight: 1.5 }}>
              {t('screens.riskSignals.aiEvalNotice')}
            </div>
          </div>
          {/* Filters */}
          <Filters
            search={search}
            setSearch={setSearch}
            severity={severity}
            setSeverity={setSeverity}
            setPage={setPage}
            status={status}
            setStatus={setStatus}
            type={type}
            setType={setType}
            selected={selected}
            handleBulkAcknowledge={handleBulkAcknowledge}
            SIGNAL_LABELS={SIGNAL_LABELS}
          />

          {/* Table */}
          <RiskSignalTable
            loading={loading}
            filteredSignals={filteredSignals}
            selected={selected}
            toggleAll={toggleAll}
            toggleSelect={toggleSelect}
            fmtDate={fmtDate}
            handleAcknowledge={handleAcknowledge}
            actionLoading={actionLoading}
            handleResolve={handleResolve}
            setDismissTarget={setDismissTarget}
            SIGNAL_LABELS={SIGNAL_LABELS}
          />

          {/* Pagination */}
          {pages > 0 && <Pagination PAGE_SIZE={PAGE_SIZE} page={page} total={total} pages={pages} setPage={setPage} setPageSize={setPageSize} />}
        </div>
      </div>

      {/* Dismiss modal */}
      {dismissTarget && <DismissModal signal={dismissTarget} onConfirm={handleDismissConfirm} onCancel={() => setDismissTarget(null)} />}

      {/* Config panel disabled — AI features not enabled in evaluation */}
    </AppLayout>
  );
};

export default RiskSignalsScreen;
